import { ClassName } from "@busybusy/webapp-react-ui";
import classNames from "classnames";
import HeaderDialog from "components/foundation/dialogs/HeaderDialog/HeaderDialog";
import { t } from "i18next";
import CertificationLinkForm, { ICertificationLinkFormData } from "../CertificationLinkForm/CertificationLinkForm";

export interface ICertificationLinkDialogProps {
  subtitle: string;
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  onSubmit: (data: ICertificationLinkFormData) => void;
  existingCertificationIds?: string[];
  certificationId?: string;
  className?: ClassName;
}

const CertificationLinkDialog = (props: ICertificationLinkDialogProps) => {
  const { subtitle, isOpen, onClose, onDelete, onSubmit, existingCertificationIds, certificationId, className } = props;

  const classes = classNames('certification-link-dialog', className);

  return (
    <HeaderDialog
      title={certificationId ? t('Required Certification') : t('New Required Certification')}
      subtitle={subtitle}
      isOpen={isOpen}
      onClose={onClose}
      divider={false}
      className={classes}
    >
      <CertificationLinkForm
        onDelete={onDelete}
        onSubmit={onSubmit}
        existingCertificationIds={existingCertificationIds}
        certificationId={certificationId}
        className="p-6"
      />
    </HeaderDialog>
  )
}

export default CertificationLinkDialog;